import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeNotificationCount, initNotification } from '../../app/notification/ducks/notificationCount';
import { initialAuthenicate } from 'app/user/auth/ducks/auth';
try{
    Notification.requestPermission().then(function(result) {
        console.log('알림: ', result);
    });
}catch(e){
    console.log(e);
}


let eventSource = undefined;
let oldCount = 0;
const blopSound= new Audio(`${process.env.PUBLIC_URL}/static/sounds/blop.mp3`)
//sessionStorage로 변경 근데 굳이?
export default function useNotification(){
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);  
    const [listening, setListening] = useState(false);
    
    useEffect(() => {
        if( auth.authenticated && !auth.restricted && !listening){
            eventSource = new EventSource(`${process.env.REACT_APP_API_HOST}/api/notification/subscribe?token=${encodeURIComponent(sessionStorage.getItem('sseToken'))}`, 
            {
                // cors:{
                //     allRoutes: true,
                //     allowOrigins: '*',
                //     allowCredentials: false,
                // },
                // withCredentials:true
            }
            );

            eventSource.onopen = event=>{
                console.log('#sse open');
                
            };

            eventSource.onmessage = (event)=>{
                if(event.data==='WARNING'){
                    dispatch(initialAuthenicate());  
                }else{
                    const count = Number(event.data);
                
                    dispatch(changeNotificationCount(count));
                    if(count!==0 && count>oldCount){
                        try{
                            if( blopSound.readyState===0)return;
                            try{
                                var notification = new Notification('독서길라잡이', { body: count+'개의 알림이 있습니다.'
                                    // , icon:  
                                });
                                //여기서 알림
                                setTimeout(notification.close.bind(notification), 3000);
                            }catch(ex){
    
                            }
                            if(blopSound.paused)blopSound.play();
                        }catch(ex){
                            console.log(ex);
                        }
                    }
                    oldCount = count;
                }
            }

            eventSource.onerror = event=>{
                console.log('#sse error');
                console.log(event);
                // 재연결을 되게 하려면..
                // eventSource.close();
            }
            setListening(true);
            dispatch( initNotification() );
        }

        if( listening && !auth.authenticated && eventSource!==undefined ){
            console.log('#sse close');
            eventSource.close();
            eventSource = undefined;
            setListening(false);
        }
    }, [auth, dispatch, listening]);
};